// extracted by mini-css-extract-plugin
export var emsContainer = "bW_h7";
export var emsInfo = "bW_h8";
export var emsInfoHeader = "bW_h9";
export var emsPhoneImgContainer = "bW_jb";